<template>
  <div>
    <div class="y-form-group">
      <el-row class="y-form-group-header">
        <el-col class="y-form-group-header__icon icon-setup-products" :span="4">&nbsp;</el-col>
        <el-col
          class="y-form-group-header__text"
          :span="20"
        >{{ $lang.messages.setup_header_products }}</el-col>
      </el-row>
      <div class="y-form-item-group">
        <el-row :gutter="50">
          <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
            <div class="y-form-row y-form-row__fullwidth">
              <label
                class="y-form-label y-form-label__heavy is-required"
              >{{ $lang.messages.form_label_type_of_customer }}</label>
              <el-radio-group class="y-radio-group y-radio-group__vertical" v-model="isAppCustomer">
                <el-radio :label="true">API & Apps</el-radio>
                <el-radio :label="false">API Only</el-radio>
              </el-radio-group>
            </div>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">
            <div class="y-checkbox-group y-checkbox-group-vertical">
              <div class="product-list-ctr">
                <div class="ref-api-products">
                  <template v-for="(api,index) in productConfig">
                    <el-checkbox
                      v-model="api.enabled"
                      :key="index"
                      class="y-checkbox y-label-bold"
                    >{{api.value}}</el-checkbox>
                  </template>
                </div>
                <div class="ref-app-products" v-if="isAppCustomer === true">
                  <template v-for="(app,index) in appProducts">
                    <el-checkbox
                      v-model="app.enabled"
                      :key="index"
                      class="y-checkbox y-label-bold"
                      :class="index == appProducts.length - 1 ? 'last': ''"
                    >{{app.displayName}}</el-checkbox>
                  </template>
                </div>
              </div>
              <div class="ref-app-finapps finapps-checkbox-ctr" v-if="isAppCustomer === true">
                <el-row :gutter="50">
                  <template v-for="(finapp, index) in finappList">
                    <el-col :key="index" :span="12">
                      <el-checkbox v-model="finapp.enabled" class="y-checkbox">{{finapp.value}}</el-checkbox>
                    </el-col>
                    <el-col :key="finapp.value" :span="12"></el-col>
                  </template>
                </el-row>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-button class="y-button" @click="saveProduct">Save</el-button>
  </div>
</template>

<script>
import serviceRegistery from '../../mixins/serviceRegistery'
export default {
  name: 'SetupProducts',
  components: {},
  data() {
    return {
      productsSetupForm: {
        typeOfCustomer: 'apiApps'
      }
    }
  },
  computed: {
    isAppCustomer: {
      get() {
        let generalConfig = this.setupTemplateData.config.generalConfig
        return generalConfig.isAppCustomer
      },
      set(value) {
        let generalConfig = this.setupTemplateData.config.generalConfig
        generalConfig.isAppCustomer = value
      }
    },
    setupTemplateData() {
      return this.$store.state.createSubbrandStore.setupTemplateData
    },
    productConfig() {
      let products = this.setupTemplateData.config.productConfig
      const productList = Object.values(products)
      return productList
    },
    appProducts() {
      let apps = this.setupTemplateData.config.appConfig
      const appList = Object.values(apps)
      return appList
    },
    finappList() {
      let finapps = this.setupTemplateData.config.appConfig.pfm.finapps
      const finappList = Object.values(finapps)
      return finappList
    }
  },
  created() {},
  methods: {
    saveProduct() {
      console.log('Save Product Details')
      this.$validator.validateAll().then(result => {
        if (result) {
          console.log('All Valid')
        }
      })
      var subbrandDataObj = {
        config: {
          generalConfig: {
            isAppCustomer: this.$store.state.createSubbrandStore
              .setupTemplateData.config.generalConfig.isAppCustomer
          },
          productConfig: this.$store.state.createSubbrandStore.setupTemplateData
            .config.productConfig,
          appConfig: this.$store.state.createSubbrandStore.setupTemplateData
            .config.appConfig
        }
      }
      let _id = this.$store.state.appStore.selectedSubbrandInfo._id
      let reqObj = {
        id: _id,
        jsonData: JSON.stringify(subbrandDataObj)
      }

      console.log('Update Request Obj------>', subbrandDataObj)
      if (_id) {
        serviceRegistery
          .makeCall({
            url: this.$hostname + 'services/subbrand/update',
            method: 'POST',
            data: reqObj
          })
          .then(response => {
            console.log(response)
            console.log('Sub-brand Data Updated-->', response.data)
            this.$store.state.appStore.selectedSubbrandInfo = response.data
          })
          .catch(error => {
            console.log('Error while updating', error.response.data)
          })
      } else {
        console.log('Sub-brand not avaliable to save')
      }
    }
  }
}
</script>

<style>
.main-ctr {
  width: 100%;
  display: block;
}
</style>
